import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["innerHTML"]

import Calendar from '@/components/Calendar.vue'
import DaysUsage from '@/components/DaysUsage.vue'
import Analysis from '@/components/Analysis.vue'
import TextContent from '@/components/TextContent.vue'
import Financial from '@/components/Financial.vue'
import { translate } from '@/helpers/translate'
import LanguageSelector from '@/components/LanguageSelector.vue'
import DaysChart from '@/components/DaysChart.vue'
import Settings from '@/components/Settings.vue'
import FinancialMonthly from '@/components/FinancialMonthly.vue'
import { useLeaveStore } from '@/stores/leave'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { t } = translate()
const leaveStore = useLeaveStore()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createElementVNode("header", {
      class: _normalizeClass(_ctx.$style.header)
    }, [
      _createVNode(TextContent, null, {
        default: _withCtx(() => [
          _createElementVNode("h1", null, _toDisplayString(_unref(t)('title')), 1)
        ]),
        _: 1
      }),
      _createVNode(LanguageSelector)
    ], 2),
    _createElementVNode("main", {
      class: _normalizeClass(_ctx.$style.main)
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style.left)
      }, [
        _createVNode(Settings),
        _createVNode(Calendar)
      ], 2),
      (_unref(leaveStore).personal.dueDate)
        ? (_openBlock(), _createElementBlock("aside", {
            key: 0,
            class: _normalizeClass(_ctx.$style.aside)
          }, [
            _createVNode(DaysChart),
            _createElementVNode("table", {
              class: _normalizeClass(_ctx.$style.table)
            }, [
              _createVNode(DaysUsage),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  colspan: "3",
                  class: _normalizeClass(_ctx.$style.spacer)
                }, null, 2)
              ]),
              _createVNode(FinancialMonthly),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  colspan: "3",
                  class: _normalizeClass(_ctx.$style.spacer)
                }, null, 2)
              ]),
              _createVNode(Financial)
            ], 2),
            _createVNode(TextContent, {
              class: _normalizeClass(_ctx.$style.about)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  innerHTML: _unref(t)('feedbackHtml')
                }, null, 8, _hoisted_1)
              ]),
              _: 1
            }, 8, ["class"])
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})